import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RxFor } from '@rx-angular/template/for';
import { AssignmentOptimizerKpiDto } from '@wilson/interfaces';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { TimelineDraftModeKpiTranslationHelperService } from '../../../services/timeline-draft-mode-kpi-translation-helper.service';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'wilson-timeline-draft-header-kpi-section',
  imports: [
    CommonModule,
    NzSkeletonModule,
    TranslateModule,
    NzTooltipModule,
    RxFor,
  ],
  templateUrl: './timeline-draft-header-kpi-section.component.html',
  styleUrls: ['./timeline-draft-header-kpi-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineDraftHeaderKPISectionComponent {
  private readonly timelineDraftModeKpiTranslationHelperService = inject(
    TimelineDraftModeKpiTranslationHelperService,
  );

  protected globalAssignmentKpisWithTranslations$: Observable<
    (AssignmentOptimizerKpiDto & {
      translatedName: string;
      translatedDescription: string;
    })[]
  > = of([]);

  @Input() isKPICardOpen = true;

  @Input() set globalAssignmentKpis(
    value: AssignmentOptimizerKpiDto[] | undefined,
  ) {
    if (value) {
      this.globalAssignmentKpisWithTranslations$ =
        this.timelineDraftModeKpiTranslationHelperService.transformDataToTranslatedData(
          value,
        );
    }
  }

  @Input() isLoadingUserAssignmentKpi = false;
}
